/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

// import avatar from "assets/img/faces/marc.jpg";
import avatar from "assets/img/capuchin-illustration.png";
import { CardHeader, Typography } from "@material-ui/core";

const styles = {
  cardCategoryWhite: {
    color: "red",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "black",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    textDecoration: "none",
    padding: "20px"
  },
  mTop: {
    marginTop: "20px"
  },
  table: {
    minWidth: 650
  },
  red: {
    color: "red"
  }
};

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardTitle}>Username Here</h4>
             <Typography> Admission Status:  <span className={classes.red}> Not yet Admitted </span></Typography>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={8}>
          <GridContainer>
            <h3>Personal Information.</h3>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Application Number
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Surname
                    </TableCell>
                    <TableCell> Unavailable </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Baptism Name
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Other Names
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Date of Birth
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      State
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Telephone
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Date Registered
                    </TableCell>
                    <TableCell>Unavailable</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} md={12} sm={12}>
          <h3 className={classes.mTop}>Academic Information.</h3>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Name of School
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Town Schooled
                  </TableCell>
                  <TableCell> Unavailable </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    From
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    To
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} md={12} sm={12}>
          <h3 className={classes.mTop}>Parent / Guardian Information.</h3>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Father's Name
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Mother's Name
                  </TableCell>
                  <TableCell> Unavailable </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Mother or Father's Email
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Mother or Father's Phone Number
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Age
                  </TableCell>
                  <TableCell>Unavailable</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3 className={classes.mTop}> O'level Result </h3>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell> S / N </TableCell>
                  <TableCell>Subject</TableCell>
                  <TableCell> Grade </TableCell>
                  <TableCell> Examination </TableCell>
                  <TableCell> Exam Date </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> 1 </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3 className={classes.mTop}> Other Institution and Credentials </h3>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell> S / N </TableCell>
                  <TableCell>Institute Name</TableCell>
                  <TableCell> Credential </TableCell>
                  <TableCell> Date Uploaded </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> 1 </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3 className={classes.mTop}> Work Experience </h3>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell> Occupation </TableCell>
                  <TableCell>Family's Choice</TableCell>
                  <TableCell> God's Calling </TableCell>
                  <TableCell> Information </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                  <TableCell> Unavailable </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <Card>
          <h2 className={classes.cardTitleWhite}> Declaration </h2>
          <CardBody>
            <Typography>
              I, Name the undersigned, declare that the information given is
              substantially complete and correct and that I know that otherwise
              my application will be rejected at any stage.
            </Typography>
          </CardBody>
          <CardFooter>
            <Typography className={classes.cardCategoryWhite}>
              Application form not yet submitted
            </Typography>
          </CardFooter>
        </Card>
      </GridContainer>
      <GridItem item xs={12} sm={12} md={12}>
        <Button color="info" className={classes.mTop}>
          Submit Application finally
        </Button>
      </GridItem>
      <GridContainer>
        <Card>
          <CardBody>
            FOR YOUR APPLICATION TO BE PROCESSED PLEASE BRING ALONG AS YOU COME
            FOR INTERVIEW
            <ul>
              <li> Crosscheck and make sure form properly filled; </li>
              <li> Your autobiography as requested above; </li>
              <li> A photocopy and original copy of your Baptism Card </li>
              <li>
                {" "}
                Photocopies and original copies of ALL your S. S. C. E (
                W.A.E.C) result slips or certificates{" "}
              </li>
              <li> Two passport photographs </li>
              <li>
                {" "}
                Photocopies and original copies of the testimonials of all the
                secondary schools you attended.{" "}
              </li>
              <li>
                {" "}
                Personal toiletries for your stay in the friary and enough
                transport money{" "}
              </li>
            </ul>
          </CardBody>
        </Card>
      </GridContainer>
    </div>
  );
}
